export function subscribeToConnectivity({
  isNative,
  loadNativeNetwork = async () => {
    const { Network } = await import('@capacitor/network');
    return Network;
  },
  navigatorObject = navigator,
  onChange,
  onError = () => {},
  windowObject = window,
}) {
  let active = true;
  let nativeListener;
  const publish = (connected) => {
    if (active) onChange(connected);
  };
  const offline = () => publish(false);
  const online = () => publish(true);

  windowObject.addEventListener('offline', offline);
  windowObject.addEventListener('online', online);

  async function subscribeNative() {
    const Network = await loadNativeNetwork();
    if (!active) return;

    const status = await Network.getStatus();
    if (!active) return;

    publish(status.connected);
    const listener = await Network.addListener('networkStatusChange', (next) =>
      publish(next.connected),
    );
    if (active) nativeListener = listener;
    else await listener.remove();
  }

  if (isNative) {
    void subscribeNative().catch((error) => {
      if (active) onError(error);
    });
  } else if (!navigatorObject.onLine) {
    publish(false);
  }

  return () => {
    active = false;
    windowObject.removeEventListener('offline', offline);
    windowObject.removeEventListener('online', online);
    void nativeListener?.remove();
  };
}
